import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaChartPie, FaShoppingCart, FaGamepad, FaLock, FaServer, FaImages, FaChartLine, FaHistory, FaArrowRight } from 'react-icons/fa';
import './Homepage.scss';
import Header from '../Header';
import Footer from '../Footer/Footer';
import TelegramPopup from '../../Common/TelegramPopup/TelegramPopup';
import HomepageCard from '../../Common/HomepageCard/HomepageCard';
import samuraiGif from '../../../assets/reddickssamurai.webm';
import hussJpg from '../../../assets/reddickshuss.jpg';
import reddickRedNoBg from '../../../assets/reddickrednobackground.png';
import wontbedeceived from '../../../assets/wontbedeceived.png';

const Homepage = () => {
  useEffect(() => {
    // Remove window.scrollTo as it's now handled globally by ScrollToTop
    // Add a class to body to ensure scrolling works properly
    document.body.style.overflow = 'auto';
    
    return () => {
      // Clean up body style when component unmounts
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <div className="homepage">
      <Header />

      <main className="homepage-content">
        {/* Hero Section */}
        <section className="hero-section hp-hero">
          <HomepageCard />
          <div className="container">
            <div className="hero-content-wrapper">
              <div className="hero-text-content">
                <h1>Welcome to Reddicks</h1>
                <img src={reddickRedNoBg} alt="Reddick" className="hero-reddick-image" />
                <p className="subtitle">Come for the questionable name, stay for the ridiculously good Radix tech (and the $DCKS).</p>
                <Link to="/buy" className="cta-button hp-cta">Get Your Reddicks</Link>
              </div>
            </div>
          </div>
        </section>

        {/* About Section (Migrated Content) */}
        <section className="about-section hp-about">
          <div className="container">
            <div className="about-columns">
              <div className="about-column left-column">
                <h2 className="section-title text-left">What is Reddicks?</h2>
                <div className="about-text">
                  <p>Reddicks is a <strong>community-driven memecoin</strong> built on the Radix network, dedicated to making the ecosystem thrive and introducing people to RadixDLT - <strong>the most technologically advanced platform</strong> in the crypto universe.</p>
                  <p>Radix stands apart with its <strong>unique approach to scaling, security, and developer experience</strong>. It solves the blockchain trilemma with its <strong>Cerberus consensus algorithm</strong>, offers secure by design developer tools, and provides a better user experience than any other DLT platform.</p>
                  <p>Reddicks is more than just a memecoin - it's a <strong>movement to bring awareness to Radix's groundbreaking technology</strong> while building a vibrant, supportive community.</p>
                  <p>Launched initially on the Rly.fun launchpad, we keep the community informed with <strong>constant updates about the Reddicks treasury activities</strong> posted in the comments section of our <a href="https://rly.fun/REDDICKS" target="_blank" rel="noopener noreferrer" style={{ color: '#2196F3' }}>Rly.fun project page</a>.</p>
                </div>
                <div className="radix-card">
                  <h3>Radix DLT</h3>
                  <ul>
                    <li>Infinite scalability via Cerberus consensus</li>
                    <li>Asset-oriented programming with Scrypto</li>
                    <li>Atomic composability across shards</li>
                    <li>Best-in-class developer experience</li>
                    <li>Superior security by design</li>
                  </ul>
                  <a href="https://learn.radixdlt.com/article/how-to-download-and-setup-the-radix-wallet" target="_blank" rel="noopener noreferrer" className="radix-link">Get Started with Radix</a>
                </div>
              </div>
              
              <div className="about-column right-column">
                <h2 className="section-title text-left">Why Choose Reddicks?</h2>
                <div className="about-text">
                  <p>REDDICKS is designed to perform alongside Radix (XRD), offering a <strong>secure way</strong> to join its exciting growth journey without the usual risks. We've tackled common crypto pitfalls head-on: benefit from <strong>massive, locked liquidity (currently over $1M!)</strong>, <strong>making rug pulls impossible</strong> and ensuring stable trading. Plus, enjoy industry-leading <strong>low fees</strong>, saving you significantly on every transaction.</p>
                  
                  <p>But REDDICKS is more than just a safe bet. We actively support other Radix ecosystem projects through our growing treasury. Impressively, <strong>20% of all treasury funds are dedicated to charitable causes</strong>, starting with combating human trafficking.</p>
                  
                  <p>We built REDDICKS to be the <strong>meme coin that respects its holders and serves a greater purpose</strong>. Experience a coin that's truly different.</p>
                  
                  <div className="button-container">
                    <Link to="/whyreddicks" className="cta-button hp-cta">Discover More 🔥</Link>
                  </div>
                  <div className="wontbedeceived-container">
                    <img src={wontbedeceived} alt="You won't be deceived!" className="wontbedeceived-image" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Features Preview Section */}
        <section className="features-preview-section hp-features">
          <div className="container">
            <h2 className="section-title">Explore the Reddicks Ecosystem</h2>
            <div className="features-grid">
              <div className="feature-card">
                <FaChartPie className="feature-icon" />
                <h3>Tokenomics</h3>
                <p>See how our tokens are distributed, locked, and allocated for community growth and stability.</p>
                <Link to="/tokenomics" className="feature-button">Tokenomics</Link>
              </div>
              <div className="feature-card">
                <FaShoppingCart className="feature-icon" />
                <h3>Buy Reddicks</h3>
                <p>Trade easily on Radix's most liquid DEX. Get your hands on some Reddicks. Go on.</p>
                <Link to="/buy" className="feature-button">How to Buy</Link>
              </div>
              <div className="feature-card">
                <FaGamepad className="feature-icon" />
                <h3>Reddicks P2E Game</h3>
                <p>Play our 3D cyberpunk tycoon game & earn.</p>
                <Link to="/game-info" className="feature-button">Let's try!</Link>
              </div>
              <div className="feature-card">
                <FaLock className="feature-icon" />
                <h3>$DCKS Staking</h3>
                <p>Earn passive $DCKS rewards with no risk. Put your $DCKS to work - they enjoy it.</p>
                <Link to="/stake" className="feature-button">Stake $DCKS</Link>
              </div>
              <div className="feature-card"> 
                <FaServer className="feature-icon" /> 
                <h3>$XRD Staking</h3>
                <p>Support Radix & earn bonus $DCKS via our validator.</p>
                <Link to="/validator" className="feature-button">Stake $XRD</Link>
              </div>
              <div className="feature-card">
                <FaImages className="feature-icon" /> 
                <h3>Meme Collection</h3>
                <p>Explore community-created memes celebrating Reddicks and the Radix ecosystem.</p>
                <Link to="/memecollection" className="feature-button">View Memes</Link>
              </div>
            </div>
          </div>
        </section>

        {/* Community Meme Section */}
        <section className="community-meme-section hp-community">
          <div className="container">
            <h2 className="section-title">Built By The Community, For The Community</h2>
            <div className="community-content">
              <div className="community-video">
                <video 
                  src={samuraiGif} 
                  alt="Reddicks Samurai Meme" 
                  className="community-webm"
                  autoPlay 
                  loop 
                  muted 
                  playsInline 
                />
              </div>
              <div className="community-text">
                <p>Reddicks thrives on the energy and creativity of its members. We're more than just code; we're a collective pushing the boundaries of what a memecoin can be on Radix.</p>
                <p>Explore our collection of community-created memes that capture the spirit of Reddicks!</p>
                <Link to="/memecollection" className="cta-button hp-cta community-cta-override">View Meme Collection</Link>
              </div>
              <div className="community-image">
                <img src={hussJpg} alt="Reddicks Huss Meme" />
              </div>
            </div>
          </div>
        </section>

        {/* Treasury Section (Migrated Content) */}
        <section className="treasury-section hp-treasury">
          <div className="container">
            <h2 className="section-title">Our Ecosystem Treasury</h2>
            <div className="treasury-content">
              <div className="treasury-text">
                <p>The Reddicks Treasury is dedicated to fueling the growth of the Radix ecosystem. We strategically invest in community tokens, NFTs, and provide liquidity to bolster promising Radix projects.</p>
                <p>Our goal is to support innovation and strengthen the Radix network. A significant portion of our treasury is also committed to charitable causes, starting with combating human trafficking.</p>
                <p>For a detailed look at our holdings and the latest updates on our treasury activities, please visit our dedicated Treasury page.</p>
              </div>
              <div className="treasury-cards">
                <div className="treasury-action-card">
                  <div className="card-icon">
                    <FaChartLine />
                  </div>
                  <div className="card-content">
                    <h3>Vault Holdings</h3>
                    <p>Explore our diverse portfolio of Radix ecosystem tokens and assets, constantly growing to support the network.</p>
                    <Link to="/treasury#vault-holdings" className="card-link">
                      View Holdings <FaArrowRight className="arrow-icon" />
                    </Link>
                  </div>
                </div>
                
                <div className="treasury-action-card">
                  <div className="card-icon">
                    <FaHistory />
                  </div>
                  <div className="card-content">
                    <h3>Treasury Chronicle</h3>
                    <p>Stay updated with the latest treasury activities, acquisitions, and charitable initiatives from the Reddicks team.</p>
                    <Link to="/treasury#treasury-chronicle" className="card-link">
                      Read Updates <FaArrowRight className="arrow-icon" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="treasury-cta-container">
                <Link to="/treasury" className="main-treasury-cta">
                  Explore the Complete Treasury
                </Link>
              </div>
            </div>
          </div>
        </section>

      </main>

      <Footer />
      <TelegramPopup />
    </div>
  );
};

export default Homepage; 